import l1 from "../../assets/l1.png";
import t1 from "../../assets/t1.png";
import y1 from "../../assets/y1.png";
import f1 from "../../assets/f1.png";
import i1 from "../../assets/i1.png";
import d1 from "../../assets/d1.png";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <div className="mb-24">
      <div className="grid grid-cols-3 gap-10 mobile:grid-cols-1 px-10">
        <div className="flex flex-col justify-center">
          <h2 className="font-poppins font-bold text-lg leading-7 text-white opacity-80">
            Unique music
          </h2>
          <p className="mt-2 font-mulish font-normal text-base leading-6 text-white opacity-60">
            Our AI combines advanced music theory and production concepts to
            deliver unique music.
          </p>
        </div>
        <div className="flex flex-col justify-center">
          <h2 className="font-poppins font-bold text-lg leading-7 text-white opacity-80">
            Unlimited Customization
          </h2>
          <p className="mt-2 font-mulish font-normal text-base leading-6 text-white opacity-60">
            Customize the length, genre, mood and instruments to create your
            music tracks.
          </p>
        </div>
        <div className="flex flex-col justify-center">
          <h2 className="font-poppins font-bold text-lg leading-7 text-white opacity-80">
            Streamlined Output
          </h2>
          <p className="mt-2 font-mulish font-normal text-base leading-6 text-white opacity-60">
            Production-ready music with industry standard mixing and mastering.
          </p>
        </div>
      </div>
      <hr className="my-8 text-white opacity-20"></hr>
      <div className="grid grid-cols-2 gap-24 mobile:grid-cols-1 px-10">
        <div className="flex flex-col justify-center mobile:hidden">
          <h2 className="font-mulish font-normal text-white opacity-60 text-base ">
            Beatoven.ai utilizes advanced AI music generation techniques to
            create mood-based music tailored to complement your content. Ideal
            for video, podcast, and game creators.
          </h2>
          <div className="mt-7 mobile:hidden">
            <ul className="flex gap-4">
              <li>
                <a
                  href="https://discord.gg/8nXq56wwJM"
                  target="_blank"
                  rel="noreferrer"
                >
                  <img src={d1} alt="Discord" width="full" height="auto" />
                </a>
              </li>
              <li>
                <a
                  href="https://www.instagram.com/beatovenai"
                  target="_blank"
                  rel="noreferrer"
                >
                  <img src={i1} alt="instagram" width="full" height="auto" />
                </a>
              </li>
              <li>
                <a
                  href="https://www.facebook.com/BeatovenAI"
                  target="_blank"
                  rel="noreferrer"
                >
                  <img src={f1} alt="Facebook" width="full" height="auto" />
                </a>
              </li>
              <li>
                <a
                  href="https://www.twitter.com/beatovenai"
                  target="_blank"
                  rel="noreferrer"
                >
                  <img src={t1} alt="Twitter" width="full" height="auto" />
                </a>
              </li>
              <li>
                <a
                  href="https://www.youtube.com/channel/UC7g8H9kQDvSska-H2tg0Y7A"
                  target="_blank"
                  rel="noreferrer"
                >
                  <img src={y1} alt="Youtube" width="full" height="auto" />
                </a>
              </li>
              <li>
                <a
                  href="https://in.linkedin.com/company/beatovenai"
                  target="_blank"
                  rel="noreferrer"
                >
                  <img src={l1} alt="LinkedIn" width="full" height="auto"  />
                </a>
              </li>
            </ul>
          </div>
          <p className="font-normal font-mulish text-base leading-6 text-white opacity-60 mt-5 mobile:hidden">
            © Copyright {new Date().getFullYear()} Beatoven Private Limited. All
            rights reserved.
          </p>
        </div>
        <div className="grid grid-cols-3 gap-2">
          <div>
            <p className="font-mulish font-bold text-base text-white opacity-80 mb-1">
              Product
            </p>
            <ul>
              <FooterListLink to={"/how-it-works"}>How It works</FooterListLink>
              <FooterListLink to={"/pricing"}>Pricing</FooterListLink>
              <FooterListLink to={"/artists"}>Artists</FooterListLink>
              <FooterListLink to={"/usecases"}>Use Cases</FooterListLink>
              <li className="mt-2">
                <a
                  href="https://forms.gle/dJsj3fa23871VzYR6"
                  target="_blank"
                  rel="noreferrer"
                  className="font-mulish font-normal text-white text-base opacity-60 hover:opacity-100"
                >
                  Copyright claim submission
                </a>
              </li>
            </ul>
          </div>
          <div>
            <p className="font-mulish font-bold text-base text-white opacity-80 mb-1">
              Company
            </p>
            <ul>
              <FooterListLink to={"/about"}>About Us</FooterListLink>
              <li className="mt-2">
                <a
                  href="https://www.beatoven.ai/blog/"
                  target="_blank"
                  rel="noreferrer"
                  className="font-mulish font-normal text-white text-base opacity-60 hover:opacity-100"
                >
                  Blog
                </a>
              </li>
              <FooterListLink to={"/contact"}>Contact Us</FooterListLink>
            </ul>
          </div>
          <div>
            <p className="font-mulish font-bold text-base text-white opacity-80 mb-1">
              Legal
            </p>
            <ul>
              <FooterListLink to={"/tos"}>Terms Of Use</FooterListLink>
              <FooterListLink to={"/privacy"}>Privacy Policy</FooterListLink>
            </ul>
          </div>
        </div>
        <div className="hidden mobile:flex mobile:flex-col mobile:justify-center mobile:-mt-5">
          <h2 className="font-mulish font-normal text-white opacity-60 text-base">
            Create unique royalty-free music that fits your story with
            Beatoven.ai. We use advanced AI music generation techniques to
            compose unique mood-based music to suit every part of your video or
            podcast.
          </h2>
          <div className="mt-7">
            <ul className="flex gap-4">
              <li>
                <a
                  href="https://discord.gg/8nXq56wwJM"
                  target="_blank"
                  rel="noreferrer"
                >
                  <img src={d1} alt="Discord" width="full" height="auto" />
                </a>
              </li>
              <li>
                <a
                  href="https://www.instagram.com/beatovenai"
                  target="_blank"
                  rel="noreferrer"
                >
                  <img src={i1} alt="Instagram" width="full" height="auto" />
                </a>
              </li>
              <li>
                <a
                  href="https://www.facebook.com/BeatovenAI"
                  target="_blank"
                  rel="noreferrer"
                >
                  <img src={f1} alt="Facebook" width="full" height="auto" />
                </a>
              </li>
              <li>
                <a
                  href="https://www.twitter.com/beatovenai"
                  target="_blank"
                  rel="noreferrer"
                >
                  <img src={t1} alt="Twitter" width="full" height="auto" />
                </a>
              </li>
              <li>
                <a
                  href="https://www.youtube.com/channel/UC7g8H9kQDvSska-H2tg0Y7A"
                  target="_blank"
                  rel="noreferrer"
                >
                  <img src={y1} alt="Youtube" width="full" height="auto" />
                </a>
              </li>
              <li>
                <a
                  href="https://in.linkedin.com/company/beatovenai"
                  target="_blank"
                  rel="noreferrer"
                >
                  <img src={l1} alt="LinkedIn" width="full" height="auto" />
                </a>
              </li>
            </ul>
          </div>
          <p className="font-normal font-mulish text-base leading-6 text-white opacity-60 mt-5">
            © Copyright {new Date().getFullYear()} Beatoven Private Limited. All
            rights reserved.
          </p>
        </div>
      </div>
    </div>
  );
};

function FooterListLink({ to, children }) {
  return (
    <li className="mt-2">
      <Link
        to={to}
        rel="noreferrer"
        className="font-mulish font-normal text-white text-base opacity-60 hover:opacity-100"
      >
        {children}
      </Link>
    </li>
  );
}

export default Footer;
